import * as React from 'react';
export default (function () {
  return React.createElement("svg", {
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32"
  }, React.createElement("title", null, "Artboard 1"), React.createElement("rect", {
    width: "32",
    height: "32",
    fill: "#0052cc"
  }), React.createElement("path", {
    fill: "#ffffff",
    d: "M23.88,15.77a4,4,0,0,0-4.78-6.3,4,4,0,0,0-6.21,0,4,4,0,0,0-4.78,6.3A4.87,4.87,0,0,0,6,20v2a1,1,0,0,0,1,1h4v1a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1h0V23h4a1,1,0,0,0,1-1V20A4.87,4.87,0,0,0,23.88,15.77ZM16,10a2,2,0,1,1-2,2A2,2,0,0,1,16,10Zm-5,9.06V21H8V20a2.77,2.77,0,0,1,3-3l.37,0A5.77,5.77,0,0,0,11,19.06ZM11,15a2,2,0,1,1,2-2A2,2,0,0,1,11,15Zm8,8H13V19.06A2.8,2.8,0,0,1,16,16a2.8,2.8,0,0,1,3,3.06Zm0-10a2,2,0,1,1,2,2A2,2,0,0,1,19,13Zm5,8H21V19.06A5.77,5.77,0,0,0,20.63,17L21,17a2.77,2.77,0,0,1,3,3Z"
  }));
});